// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"Sidebar_Sidebar__2VTmp","SidebarItems":"Sidebar_SidebarItems__9kEw9"};